module.exports = __webpack_public_path__ + "static/911-65188533b51eccad55624d7ab7f7a529.png";